export const COLOR_SWATCHES_BREAKPOINTS = {
  MOBILE_MAX: 767,
  TABLET_MIN: 768,
  TABLET_MAX: 1023,
  DESKTOP_MIN: 1024,
};
export const EXPANDABLE_THRESHOLDS = {
  DESKTOP: {
    COLOR: 12,
    IMAGE: 6,
  },
  TABLET: {
    COLOR: 20,
    IMAGE: 12,
  },
  MOBILE: {
    COLOR: 10,
    IMAGE: 8,
  },
};

const THRESHOLDS_V1 = {
  desktop: { COLOR: 12, IMAGE: 6 },
  tablet: { COLOR: 20, IMAGE: 12 },
  mobile: { COLOR: 10, IMAGE: 8 },
};

export const getInitialVisibleCount = (deviceType, variantSwatchType, isModernLineContainerEnabled) => {
  if (isModernLineContainerEnabled) {
    return 6;
  }

  const threshold = THRESHOLDS_V1;
  const deviceThreshold = threshold[deviceType] || threshold.desktop;
  const containerThreshold = deviceThreshold[variantSwatchType] || deviceThreshold.COLOR;

  return Math.floor(containerThreshold / 2);
};

/**
 * @param {number} screenWidth
 * @returns {string}
 */
export const getDeviceType = (screenWidth = typeof window !== 'undefined' ? window.innerWidth : 1024) => {
  if (screenWidth >= COLOR_SWATCHES_BREAKPOINTS.DESKTOP_MIN) {
    return 'desktop';
  }
  if (screenWidth >= COLOR_SWATCHES_BREAKPOINTS.TABLET_MIN && screenWidth <= COLOR_SWATCHES_BREAKPOINTS.TABLET_MAX) {
    return 'tablet';
  }
  return 'mobile';
};

/**
 * @param {string} variantSwatchType
 * @param {Array} colorVariants
 * @param {string} deviceTypeFromAppCtx
 * @param {boolean} isModernLineContainerEnabled
 * @returns {boolean}
 */
export const shouldShowExpandable = (
  variantSwatchType,
  colorVariants,
  deviceTypeFromAppCtx,
  isModernLineContainerEnabled = false
) => {
  if (!variantSwatchType || !colorVariants) {
    return false;
  }
  let deviceType = deviceTypeFromAppCtx;

  if (!deviceType || deviceType === 'desktop') {
    const screenWidth = typeof window !== 'undefined' ? window.innerWidth : 1024;
    deviceType = getDeviceType(screenWidth);
  }
  if (deviceType === 'desktop') {
    return false;
  }

  if (isModernLineContainerEnabled) {
    return colorVariants.length > 6;
  }

  const threshold = EXPANDABLE_THRESHOLDS[deviceType.toUpperCase()]?.[variantSwatchType];
  return threshold ? colorVariants.length >= threshold : false;
};
